<template>

</template>

<script>

import { Link } from "@inertiajs/vue3"

export default {
    data() {
        return {
            navigation: [
                { name: 'Home', href: route('frontend.index'), component: 'Frontend/Index', section: 'Frontend' },
                { name: 'Organisations', href: route('frontend.organisations.index'), component: 'Frontend/Organisations', section: 'Frontend' },
                { name: 'Fixtures', href: route('frontend.fixture.index'), component: 'Frontend/Fixtures', section: 'Frontend'} ,
                { name: 'Expenses', href: route('frontend.expenses.index'), component: 'Frontend/Expenses', section: 'Frontend'},
                { name: 'Finance Import', href: '#', component: 'Frontend/Finance', section: 'Frontend'},
                { name: 'Overview', href: route('admin.index'), component: 'Admin/Index', section: 'Admin'},
                { name: 'Offices', href: route('admin.offices.index'), component: 'Admin/Offices', section: 'Admin'},
                { name: 'Bank Accounts', href: route('admin.bank-accounts.index'), component: 'Admin/BankAccounts', section: 'Admin'},
                { name: 'Users', href: route('admin.users.index'), component: 'Admin/Users', section: 'Admin'},
                { name: 'Roles', href: route('admin.roles.index'), component: 'Admin/Roles', section: 'Admin'},
                { name: 'Settings', href: route('admin.settings.index'), component: 'Admin/Settings', section: 'Admin'},
            ]
        }
    },
    components: {
        Link
    },


}
</script>
